export default __webpack_public_path__ + "static/media/right.67c7cff6.svg";